import React, { useState, useEffect } from 'react';
import cn from "classnames";

const Card = (props) => {
	const {
		header,
		children,
		className = '',
		hasIcon = false,
		isExpanded = true,
	} = props;
	const [expanded, setExpanded] = useState(isExpanded);

	useEffect(() => {
		setExpanded(isExpanded);
	}, [isExpanded]);

	const onHeaderClick = () => {
		if (hasIcon) {
			setExpanded(prev => !prev);
		}
	};

	return (
		<div className={cn('ga-card', className, { 'ga-card-expanded': expanded })}>
			<div className={cn('ga-card-header', { 'ga-card-header-icon': hasIcon })} onClick={onHeaderClick}>
				{hasIcon && (
					<i className="fa fa-caret-square-right" />
				)}
				{header}
			</div>
			<div className="ga-card-body">
				{children}
			</div>
		</div>
	);
};

export default Card;
